/* ==========================================================================
   McCalls — Collection filtering
   AJAX facets via the Section Rendering API (no reload, URL kept in sync),
   sort, dual-handle price slider, searchable / collapsible lists, size-chip
   ordering, and the mobile filter drawer.
   Markup: sections/collection.liquid + snippets/collection-filters.liquid
   Styles: assets/collection-filters.css
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-collection-page]');
  if (!root) return;

  document.documentElement.classList.add('js-filters');

  var sectionId = root.getAttribute('data-section-id');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var controller = null;
  var live = null;

  function qs(el, sel) { return el ? el.querySelector(sel) : null; }
  function qsa(el, sel) { return el ? Array.prototype.slice.call(el.querySelectorAll(sel)) : []; }
  function debounce(fn, ms) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }

  /* ── Drawer ─────────────────────────────────────────────────────────── */
  var drawer = qs(root, '[data-collection-filters-drawer]');

  function openDrawer() {
    if (!drawer) return;
    if (typeof drawer.showModal === 'function') {
      try { drawer.showModal(); } catch (_) { drawer.setAttribute('open', ''); }
    } else {
      drawer.setAttribute('open', '');
    }
  }

  function closeDrawer() {
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      try { drawer.close(); } catch (_) { drawer.removeAttribute('open'); }
    } else {
      drawer.removeAttribute('open');
    }
  }

  /* ── Region morphing ────────────────────────────────────────────────── */
  var REGIONS = [
    { sel: '.collection-page__products', mode: 'outer' },
    { sel: '.collection-page__sidebar', mode: 'inner' },
    { sel: '.collection-page__drawer-body', mode: 'inner' },
    { sel: '[data-collection-active]', mode: 'inner' },
    { sel: '[data-collection-quickbar]', mode: 'inner' },
    { sel: '.collection-page__count', mode: 'inner' },
    { sel: '[data-collection-clear]', mode: 'inner' },
    { sel: '.collection-page__filter-toggle', mode: 'inner' },
    { sel: '.collection-page__subnav', mode: 'inner' }
  ];

  function snapshotState() {
    var state = { open: {}, search: {}, more: {}, sidebarScroll: 0 };
    qsa(root, '[data-collection-filters]').forEach(function (wrap) {
      var ctx = wrap.getAttribute('data-collection-filters');
      qsa(wrap, '[data-filter-group]').forEach(function (g) {
        var key = ctx + '|' + g.getAttribute('data-filter-group');
        state.open[key] = g.open;
        var search = qs(g, '[data-filter-search]');
        if (search && search.value) state.search[key] = search.value;
        var more = qs(g, '[data-filter-more]');
        if (more && more.getAttribute('aria-expanded') === 'true') state.more[key] = true;
      });
    });
    var sidebar = qs(root, '.collection-page__sidebar');
    if (sidebar) state.sidebarScroll = sidebar.scrollTop;
    return state;
  }

  function restoreState(state) {
    qsa(root, '[data-collection-filters]').forEach(function (wrap) {
      var ctx = wrap.getAttribute('data-collection-filters');
      qsa(wrap, '[data-filter-group]').forEach(function (g) {
        var key = ctx + '|' + g.getAttribute('data-filter-group');
        if (key in state.open) g.open = state.open[key];
        var search = qs(g, '[data-filter-search]');
        if (search && state.search[key]) { search.value = state.search[key]; applySearch(search); }
        var more = qs(g, '[data-filter-more]');
        if (more && state.more[key]) toggleMore(more, true);
      });
    });
    var sidebar = qs(root, '.collection-page__sidebar');
    if (sidebar) sidebar.scrollTop = state.sidebarScroll;
  }

  function syncSortLabel(sel) {
    if (!sel || sel.selectedIndex < 0) return;
    var cur = qs(root, '[data-sort-current]');
    if (cur) cur.textContent = sel.options[sel.selectedIndex].text;
  }

  function morph(doc) {
    var newRoot = doc.querySelector('[data-collection-page]') || doc;
    REGIONS.forEach(function (r) {
      var cur = qs(root, r.sel);
      var next = qs(newRoot, r.sel);
      if (!cur && !next) return;
      if (cur && !next) { if (r.mode === 'inner') cur.innerHTML = ''; return; }
      if (!cur && next) return; // region appeared server-side but has no host here; ignore
      if (r.mode === 'outer') cur.replaceWith(next);
      else cur.innerHTML = next.innerHTML;
    });
    var count = newRoot.getAttribute('data-products-count');
    if (count != null) {
      root.setAttribute('data-products-count', count);
      var apply = qs(root, '.collection-page__drawer-apply');
      if (apply) apply.setAttribute('data-count', count);
    }
    var sortSel = qs(root, 'select[name="sort_by"]');
    var newSort = qs(newRoot, 'select[name="sort_by"]');
    if (sortSel && newSort) sortSel.value = newSort.value;
    syncSortLabel(sortSel);
    var t = doc.querySelector('title');
    if (t && t.textContent) document.title = t.textContent;
    enhance();
  }

  function announce(text) {
    if (!live) {
      live = document.createElement('span');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      root.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  }

  /* ── Navigation ─────────────────────────────────────────────────────── */
  function apply(url, opts) {
    opts = opts || {};
    var target;
    try { target = new URL(url, window.location.href); } catch (_) { window.location.href = url; return; }
    if (target.origin !== window.location.origin || !sectionId) { window.location.href = target.toString(); return; }
    /* Shopify filter links don't know about the theme-side "New in" switch — carry it across */
    if (/[?&]new=1(&|$)/.test(window.location.search) && !target.searchParams.has('new')) target.searchParams.set('new', '1');

    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    var fetchUrl = new URL(target.toString());
    fetchUrl.searchParams.set('section_id', sectionId);

    var products = qs(root, '.collection-page__products');
    if (products) products.setAttribute('aria-busy', 'true');
    qsa(root, '.collection-filters').forEach(function (f) { f.classList.add('is-loading'); });

    var state = snapshotState();
    var focusKey = opts.focusKey || null;
    var focusCtx = opts.focusCtx || null;

    fetch(fetchUrl.toString(), { signal: controller ? controller.signal : undefined, headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        morph(doc);
        try { root.dispatchEvent(new CustomEvent('collection:morphed')); } catch (_) {}
        restoreState(state);
        if (opts.push !== false) {
          try { window.history.pushState({ collectionFilters: true }, '', target.toString()); } catch (_) {}
        }
        var count = root.getAttribute('data-products-count');
        if (count != null) announce(count === '1' ? '1 item' : count + ' items');
        if (focusKey) {
          var scope = focusCtx ? qs(root, '[data-collection-filters="' + focusCtx + '"]') : root;
          var el = scope ? qs(scope, '[data-filter-key="' + cssEscape(focusKey) + '"]') : null;
          if (el) { try { el.focus({ preventScroll: true }); } catch (_) {} }
        }
        if (opts.scroll) scrollTo(opts.scroll);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = target.toString();
      })
      .then(function () {
        var p = qs(root, '.collection-page__products');
        if (p) p.removeAttribute('aria-busy');
        qsa(root, '.collection-filters').forEach(function (f) { f.classList.remove('is-loading'); });
      });
  }

  /* Bring the refreshed results into view after a filter / sort / price change
     or pagination: scroll so the collection toolbar (title · count · sort) is
     docked just beneath the sticky header with the results directly under it —
     NOT to the top of the page (intro / featured slider stay scrolled past).
     Scrolls down as well as up (David 1 Oct 2026: "when a filter is selected
     it needs to move to this sort of position") — anchored on the active
     filter pills when there are any, so they sit just under the docked bar. */
  function scrollTo(where, settling) {
    var rootStyle = getComputedStyle(document.documentElement);
    var headerOffset = parseFloat(rootStyle.getPropertyValue('--header-offset')) || 0;
    var subnavOffset = parseFloat(rootStyle.getPropertyValue('--subnav-offset')) || 0;
    var active = qs(root, '[data-collection-active]');
    var body = (active && active.children.length) ? active : (qs(root, '.collection-page__body') || root);
    var barH = parseFloat(getComputedStyle(root).getPropertyValue('--sticky-bar-height')) || 56;
    // Every filter / sort / page change lands 2px PAST the toolbar's stuck
    // threshold, so the docked bar (title · count · Size / Colour / Price…
    // pills · sort) is always showing and the results sit directly under it
    // in the same place on every click (David 7 Oct 2026: "it should show
    // that nav bar … on every click refresh so it's in the same position").
    // Previously sidebar clicks kept a 16px gap, which left the bar just
    // short of sticking and showed the plain toolbar instead.
    var pad = -2;
    var target = body.getBoundingClientRect().top + window.pageYOffset - headerOffset - subnavOffset - barH - pad;
    target = Math.max(0, Math.round(target));
    if (Math.abs(window.pageYOffset - target) >= 4) {
      window.scrollTo({ top: target, behavior: (mqReduce.matches || settling) ? 'auto' : 'smooth' });
    }
    if (settling) return;
    // The header compacts while scrolling (its height, and so the stuck
    // line, changes mid-ride) and the bar's own height changes once it
    // sticks: re-measure once the scroll has settled and correct if needed.
    var done = false;
    var settle = function () {
      if (done) return;
      done = true;
      window.removeEventListener('scrollend', settle);
      window.requestAnimationFrame(function () { scrollTo(where, true); });
    };
    if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true });
    window.setTimeout(settle, 900);
  }

  function cssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }

  function isFilterUrl(href) {
    return /[?&](filter\.|sort_by=|page=)/.test(href) || /\/collections\//.test(href);
  }

  /* ── Delegated events ───────────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;

    var openBtn = t.closest('[data-collection-filter-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    var closeBtn = t.closest('[data-collection-filter-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }

    var more = t.closest('[data-filter-more]');
    if (more) { e.preventDefault(); toggleMore(more); return; }

    var link = t.closest('a[href]');
    if (!link || !root.contains(link)) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var isFilter = link.hasAttribute('data-filter-link')
      || link.classList.contains('collection-page__active-pill')
      || link.classList.contains('collection-page__clear')
      || (link.classList.contains('sticky-bar__chip') && /[?&]filter\./.test(href))
      || (link.closest('.collection-page__pagination') && isFilterUrl(href));
    if (!isFilter) return;

    e.preventDefault();
    var wrap = link.closest('[data-collection-filters]');
    // Quick-rail clicks scroll too (David 4 Sep 2026: "when selecting filters
    // its not scrolling to top") — but to the 'dock' position, past the
    // sticky threshold, so the bar stays stuck and the rail + its reopened
    // panel aren't folded away mid-use.
    apply(href, {
      focusKey: link.getAttribute('data-filter-key'),
      focusCtx: wrap ? wrap.getAttribute('data-collection-filters') : null,
      scroll: link.closest('[data-collection-quickbar]')
        ? 'dock'
        : (link.closest('.collection-page__pagination') ? 'results' : 'top')
    });
  });

  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('select[name="sort_by"]')) {
      syncSortLabel(t);
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', t.value);
      url.searchParams.delete('page');
      apply(url.toString(), { scroll: 'top' });
      return;
    }
    if (t.matches('[data-price-range]')) { onPriceRangeChange(t); return; }
    if (t.matches('[data-price-input]')) { onPriceInputChange(t); return; }
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-price-range]')) { syncPriceFromRange(t.closest('[data-collection-price-form]'), t); return; }
    if (t.matches('[data-filter-search]')) { applySearch(t); return; }
  });

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-collection-price-form]');
    if (!form) return;
    e.preventDefault();
    applyPrice(form);
  });

  window.addEventListener('popstate', function () {
    apply(window.location.href, { push: false });
  });

  /* ── "New in" switch (theme-side, page-level) ───────────────────────── */
  function newOnlyWanted() {
    return /[?&]new=1(&|$)/.test(window.location.search);
  }

  function paintNewOnly() {
    var on = newOnlyWanted();
    root.classList.toggle('collection-page--new-only', on);
    var cards = qsa(root, '.product-card');
    var fresh = cards.filter(function (c) { return c.hasAttribute('data-new'); });
    qsa(root, '[data-filter-new-only]').forEach(function (cb) { cb.checked = on; });
    qsa(root, '[data-filter-new-count]').forEach(function (el) { el.textContent = fresh.length ? String(fresh.length) : ''; });
    qsa(root, '[data-filter-new-only]').forEach(function (cb) {
      var label = cb.closest('.collection-filters__switch');
      if (label) label.classList.toggle('is-disabled', !fresh.length && !on);
      cb.disabled = !fresh.length && !on;
    });

    var grid = qs(root, '.collection-page__grid');
    var empty = qs(root, '.collection-page__new-empty');
    if (on && grid && !fresh.length) {
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'collection-page__new-empty';
        empty.textContent = 'Nothing new on this page — turn off "New in" to see everything.';
        grid.appendChild(empty);
      }
    } else if (empty) {
      empty.parentNode.removeChild(empty);
    }

    var count = qs(root, '.collection-page__count');
    if (count) {
      if (on) {
        if (!count.hasAttribute('data-count-all')) count.setAttribute('data-count-all', count.textContent);
        count.textContent = fresh.length + (fresh.length === 1 ? ' new item' : ' new items');
      } else if (count.hasAttribute('data-count-all')) {
        count.textContent = count.getAttribute('data-count-all');
        count.removeAttribute('data-count-all');
      }
    }

    /* Most of the page is new → the NEW pill carries no information */
    if (root.hasAttribute('data-quiet-new')) {
      root.classList.toggle('collection-page--mostly-new', cards.length >= 4 && fresh.length / cards.length > 0.6);
    }
  }

  root.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-filter-new-only]');
    if (!cb) return;
    var url = new URL(window.location.href);
    if (cb.checked) url.searchParams.set('new', '1'); else url.searchParams.delete('new');
    try { window.history.replaceState(window.history.state, '', url.toString()); } catch (_) {}
    paintNewOnly();
    announce(cb.checked ? 'Showing new items only' : 'Showing all items');
  });

  paintNewOnly();
  root.addEventListener('collection:morphed', paintNewOnly);

  /* ── Sticky quick filters (toolbar dropdowns) ───────────────────────────
     The <details> groups in [data-collection-quickbar]. Their open state
     survives each morph via the shared snapshot/restore (the wrapper is a
     [data-collection-filters] context), so a panel stays open while the
     shopper multi-selects. Here: one open at a time, close on outside
     click / Escape / when the bar unsticks, and flip a panel that would
     run off the right edge of the viewport. */
  function quickGroups() {
    return qsa(root, '[data-quick-filter]');
  }

  function closeQuick(except) {
    quickGroups().forEach(function (g) {
      if (g !== except && g.open) g.open = false;
    });
  }

  // 'toggle' doesn't bubble — listen in the capture phase.
  root.addEventListener('toggle', function (e) {
    var g = e.target;
    if (!g || !g.hasAttribute || !g.hasAttribute('data-quick-filter') || !g.open) return;
    closeQuick(g);
    var panel = qs(g, '.quick-filters__panel');
    if (panel) {
      panel.classList.remove('is-flipped');
      if (panel.getBoundingClientRect().right > window.innerWidth - 8) panel.classList.add('is-flipped');
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-quick-filter]')) return;
    closeQuick();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = quickGroups().filter(function (g) { return g.open; });
    if (!open.length) return;
    var summary = qs(open[0], 'summary');
    closeQuick();
    if (summary) { try { summary.focus(); } catch (_) {} }
  });

  // Scrolled back up — the row folds away, so nothing should stay open.
  root.addEventListener('stickybar:change', function (e) {
    if (e.detail && !e.detail.stuck) closeQuick();
  });

  /* ── Price slider ───────────────────────────────────────────────────── */
  function priceParts(form) {
    return {
      rMin: qs(form, '[data-price-range="min"]'),
      rMax: qs(form, '[data-price-range="max"]'),
      iMin: qs(form, '[data-price-input="min"]'),
      iMax: qs(form, '[data-price-input="max"]'),
      slider: qs(form, '[data-price-slider]'),
      outMin: qs(form, '[data-price-readout-min]'),
      outMax: qs(form, '[data-price-readout-max]'),
      max: parseFloat(form.getAttribute('data-max')) || 1,
      cur: form.getAttribute('data-currency') || ''
    };
  }

  function paintPrice(form, lo, hi) {
    var p = priceParts(form);
    if (p.slider) {
      p.slider.style.setProperty('--cf-min', (lo / p.max * 100) + '%');
      p.slider.style.setProperty('--cf-max', (hi / p.max * 100) + '%');
    }
    if (p.outMin) p.outMin.textContent = p.cur + Math.round(lo);
    if (p.outMax) p.outMax.textContent = p.cur + Math.round(hi);
    // The handle nearest the pointer should be on top when both meet at an edge
    if (p.rMin && p.rMax) {
      var atTop = lo >= p.max - (p.max * 0.02);
      p.rMin.style.zIndex = atTop ? 3 : 2;
      p.rMax.style.zIndex = atTop ? 2 : 3;
    }
  }

  function syncPriceFromRange(form, changed) {
    if (!form) return;
    var p = priceParts(form);
    var lo = parseFloat(p.rMin.value), hi = parseFloat(p.rMax.value);
    if (lo > hi) {
      if (changed === p.rMin) { hi = lo; p.rMax.value = hi; } else { lo = hi; p.rMin.value = lo; }
    }
    if (p.iMin) p.iMin.value = lo > 0 ? lo : '';
    if (p.iMax) p.iMax.value = hi < p.max ? hi : '';
    paintPrice(form, lo, hi);
  }

  var applyPriceDebounced = debounce(function (form) { applyPrice(form); }, 350);

  function onPriceRangeChange(range) {
    var form = range.closest('[data-collection-price-form]');
    syncPriceFromRange(form, range);
    applyPriceDebounced(form);
  }

  function onPriceInputChange(input) {
    var form = input.closest('[data-collection-price-form]');
    var p = priceParts(form);
    var lo = p.iMin && p.iMin.value !== '' ? Math.max(0, parseFloat(p.iMin.value) || 0) : 0;
    var hi = p.iMax && p.iMax.value !== '' ? Math.min(p.max, parseFloat(p.iMax.value) || p.max) : p.max;
    if (lo > hi) { if (input === p.iMin) hi = lo; else lo = hi; }
    if (p.rMin) p.rMin.value = lo;
    if (p.rMax) p.rMax.value = hi;
    if (p.iMin) p.iMin.value = lo > 0 ? lo : '';
    if (p.iMax) p.iMax.value = hi < p.max ? hi : '';
    paintPrice(form, lo, hi);
    applyPriceDebounced(form);
  }

  function applyPrice(form) {
    var url = new URL(window.location.href);
    qsa(form, 'input[name]').forEach(function (input) {
      if (input.value !== '') url.searchParams.set(input.name, input.value);
      else url.searchParams.delete(input.name);
    });
    url.searchParams.delete('page');
    if (url.toString() === window.location.href) return;
    // Same rule as the click handler: the quick rail's price panel must not
    // trigger the dock scroll (it can unstick the bar and fold the rail).
    apply(url.toString(), { scroll: form.closest('[data-collection-quickbar]') ? 'dock' : 'top' });
  }

  /* ── Search-in-list / show more ─────────────────────────────────────── */
  function applySearch(input) {
    var group = input.closest('[data-filter-group]');
    if (!group) return;
    var q = input.value.trim().toLowerCase();
    var items = qsa(group, '[data-filter-item]');
    var more = qs(group, '[data-filter-more]');
    var noMatch = qs(group, '[data-filter-no-match]');
    var shown = 0;
    items.forEach(function (li) {
      var label = li.getAttribute('data-filter-label') || '';
      var isExtra = li.hasAttribute('data-filter-extra');
      var expanded = more && more.getAttribute('aria-expanded') === 'true';
      var visible;
      if (q) visible = label.indexOf(q) > -1;
      else visible = !isExtra || expanded;
      li.hidden = !visible;
      if (visible) shown++;
    });
    if (more) more.hidden = !!q;
    if (noMatch) noMatch.hidden = !(q && shown === 0);
  }

  function toggleMore(btn, force) {
    var group = btn.closest('[data-filter-group]');
    if (!group) return;
    var expanded = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    qsa(group, '[data-filter-extra]').forEach(function (li) { li.hidden = !expanded; });
    var label = qs(btn, '[data-filter-more-label]') || btn;
    var total = qsa(group, '[data-filter-item]').length;
    label.textContent = expanded ? 'Show less' : 'Show all (' + total + ')';
    if (!expanded && typeof force !== 'boolean') {
      var summary = qs(group, 'summary');
      if (summary && summary.getBoundingClientRect().top < 0) summary.scrollIntoView({ block: 'start', behavior: mqReduce.matches ? 'auto' : 'smooth' });
    }
  }

  /* ── Size chip ordering (S&D returns values alphabetically) ─────────── */
  var ALPHA = ['XXXS', '3XS', 'XXS', '2XS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', 'XXXXL', '4XL', '5XL', '6XL', '7XL', '8XL'];
  var ALPHA_RANK = {};
  ALPHA.forEach(function (s, i) { ALPHA_RANK[s] = i; });

  function sizeRank(label) {
    var s = String(label).trim().toUpperCase().replace(/\s+/g, '');
    if (ALPHA_RANK.hasOwnProperty(s)) return [0, ALPHA_RANK[s], s];
    var m = s.match(/^(\d+(?:\.\d+)?)/);
    if (m) {
      // numeric (chest / waist / collar / shoe) — keep leg-length suffix as tiebreaker
      var suffix = s.slice(m[1].length);
      var suffixRank = ({ S: 0, '': 1, R: 1, L: 2 })[suffix];
      if (suffixRank == null) suffixRank = 5;
      return [1, parseFloat(m[1]), suffixRank, s];
    }
    if (/^O\/?S$|^ONESIZE$|^ONE$/.test(s)) return [3, 0, s];
    return [2, 0, s];
  }

  function sortChips(list) {
    var items = qsa(list, 'li');
    if (items.length < 3) return;
    var withRank = items.map(function (li, i) { return { li: li, rank: sizeRank(li.textContent), i: i }; });
    withRank.sort(function (a, b) {
      for (var k = 0; k < Math.max(a.rank.length, b.rank.length); k++) {
        var x = a.rank[k], y = b.rank[k];
        if (x === y) continue;
        if (x == null) return -1;
        if (y == null) return 1;
        return x < y ? -1 : 1;
      }
      return a.i - b.i;
    });
    withRank.forEach(function (w) { list.appendChild(w.li); });
    list.setAttribute('data-sorted', '');
  }

  /* ── Enhance current DOM (called on load and after each morph) ─────── */
  function enhance() {
    qsa(root, '[data-filter-chips]').forEach(function (list) {
      var kind = list.getAttribute('data-filter-chips') || '';
      if (kind.indexOf('size') > -1 && !list.hasAttribute('data-sorted')) sortChips(list);
    });
    qsa(root, '[data-collection-price-form]').forEach(function (form) {
      var p = priceParts(form);
      if (p.rMin && p.rMax) paintPrice(form, parseFloat(p.rMin.value), parseFloat(p.rMax.value));
    });
    var count = root.getAttribute('data-products-count');
    var applyBtn = qs(root, '.collection-page__drawer-apply');
    if (applyBtn && count != null) applyBtn.setAttribute('data-count', count);
  }

  enhance();
})();
